const objects = [
  // 🍎 FRUITS
  {
    id: "apple",
    name: "Apple",
    translate: "Pomme",
    sex: "f",
    category: "fruit",
    icon: "🍎",
    model: "/models/apple.glb",
    pronunciation: "/audio/apple.mp3",
  },
  {
    id: "banana",
    name: "Banana",
    translate: "Banane",
    sex: "f",
    category: "fruit",
    icon: "🍌",
    model: "/models/banana.glb",
    pronunciation: "/audio/banana.mp3",
  },
  {
    id: "orange",
    name: "Orange",
    translate: "Orange",
    sex: "f",
    category: "fruit",
    icon: "🍊",
    model: "/models/orange.glb",
    pronunciation: "/audio/orange.mp3",
  },
  {
    id: "pear",
    name: "Pear",
    translate: "Poire",
    sex: "f",
    category: "fruit",
    icon: "🍐",
    model: "/models/pear.glb",
    pronunciation: "/audio/pear.mp3",
    question: "/audio/ou-pear.mp3",
  },
  {
    id: "strawberry",
    name: "Strawberry",
    translate: "Fraise",
    sex: "f",
    category: "fruit",
    icon: "🍓",
    model: "/models/strawberry.glb",
    pronunciation: "/audio/strawberry.mp3",
  },
  {
    id: "grape",
    name: "Grape",
    translate: "Raisin",
    sex: "m",
    category: "fruit",
    icon: "🍇",
    model: "/models/grape.glb",
    pronunciation: "/audio/grape.mp3",
  },
  {
    id: "watermelon",
    name: "Watermelon",
    translate: "Pastèque",
    sex: "f",
    category: "fruit",
    icon: "🍉",
    model: "/models/watermelon.glb",
    pronunciation: "/audio/watermelon.mp3",
  },
  {
    id: "lemon",
    name: "Lemon",
    translate: "Citron",
    sex: "m",
    category: "fruit",
    icon: "🍋",
    model: "/models/lemon.glb",
    pronunciation: "/audio/lemon.mp3",
  },
  {
    id: "peach",
    name: "Peach",
    translate: "Pêche",
    sex: "f",
    category: "fruit",
    icon: "🍑",
    model: "/models/peach.glb",
    pronunciation: "/audio/peach.mp3",
  },
  {
    id: "dog",
    name: "Dog",
    translate: "Chien",
    sex: "m",
    category: "animal",
    icon: "🐕",
    model: "/models/dog.glb",
    pronunciation: "/audio/dog.mp3",
  },
  {
    id: "cat",
    name: "Cat",
    translate: "Chat",
    sex: "m",
    category: "animal",
    icon: "🐈",
    model: "/models/cat.glb",
    pronunciation: "/audio/cat.mp3",
  },
  {
    id: "horse",
    name: "Horse",
    translate: "Cheval",
    sex: "m",
    category: "animal",
    icon: "🐎",
    model: "/models/horse.glb",
    pronunciation: "/audio/horse.mp3",
  },
  {
    id: "cow",
    name: "Cow",
    translate: "Vache",
    sex: "f",
    category: "animal",
    icon: "🐄",
    model: "/models/cow.glb",
    pronunciation: "/audio/cow.mp3",
  },
  {
    id: "chicken",
    name: "Chicken",
    translate: "Poulet",
    sex: "f",
    category: "animal",
    icon: "🐔",
    model: "/models/chicken.glb",
    pronunciation: "/audio/chicken.mp3",
  },
  {
    id: "pig",
    name: "Pig",
    translate: "Cochon",
    sex: "m",
    category: "animal",
    icon: "🐷",
    model: "/models/pig.glb",
    pronunciation: "/audio/pig.mp3",
  },

  {
    id: "giraffe",
    name: "Giraffe",
    translate: "Girafe",
    sex: "f",
    category: "animal",
    icon: "🦒",
    model: "/models/giraffe.glb",
    pronunciation: "/audio/giraffe.mp3",
  },
  {
    id: "bread",
    name: "Bread",
    translate: "Pain",
    sex: "m",
    category: "food",
    icon: "🍞",
    model: "/models/bread.glb",
    pronunciation: "/audio/bread.mp3",
    question: "/audio/ou-bread.mp3",
  },
  {
    id: "cheese",
    name: "Cheese",
    translate: "Fromage",
    sex: "m",
    category: "food",
    icon: "🧀",
    model: "/models/cheese.glb",
    pronunciation: "/audio/cheese.mp3",
  },
  {
    id: "egg",
    name: "Egg",
    translate: "Œuf",
    sex: "m",
    category: "food",
    icon: "🥚",
    model: "/models/egg.glb",
    pronunciation: "/audio/egg.mp3",
  },
  {
    id: "cake",
    name: "Cake",
    translate: "Gâteau",
    sex: "m",
    category: "food",
    icon: "🍰",
    model: "/models/cake.glb",
    pronunciation: "/audio/cake.mp3",
  },
  {
    id: "milk",
    name: "Milk",
    translate: "Lait",
    sex: "m",
    category: "food",
    icon: "🥛",
    model: "/models/milk.glb",
    pronunciation: "/audio/milk.mp3",
  },
  {
    id: "juice",
    name: "Juice",
    translate: "Jus",
    sex: "m",
    category: "food",
    icon: "🧃",
    model: "/models/juice.glb",
    pronunciation: "/audio/juice.mp3",
  },
  {
    id: "icecream",
    name: "Ice Cream",
    translate: "Glace",
    sex: "f",
    category: "food",
    icon: "🍦",
    model: "/models/icecream.glb",
    pronunciation: "/audio/icecream.mp3",
  },
  {
    id: "sofa",
    name: "Sofa",
    translate: "Canapé",
    sex: "m",
    category: "home",
    icon: "🛋️",
    model: "/models/sofa.glb",
    pronunciation: "/audio/sofa.mp3",
  },
  {
    id: "chair",
    name: "Chair",
    translate: "Chaise",
    sex: "f",
    category: "home",
    icon: "🪑",
    model: "/models/chair.glb",
    pronunciation: "/audio/chair.mp3",
  },
  {
    id: "bed",
    name: "Bed",
    translate: "Lit",
    sex: "m",
    category: "home",
    icon: "🛏️",
    model: "/models/bed.glb",
    pronunciation: "/audio/bed.mp3",
  },
  {
    id: "lamp",
    name: "Lamp",
    translate: "Lampe",
    sex: "f",
    category: "home",
    icon: "💡",
    model: "/models/lamp.glb",
    pronunciation: "/audio/lamp.mp3",
  },
  {
    id: "television",
    name: "Television",
    translate: "Télévision",
    sex: "f",
    category: "home",
    icon: "📺",
    model: "/models/tv.glb",
    pronunciation: "/audio/tv.mp3",
  },
  {
    id: "refrigerator",
    name: "Refrigerator",
    translate: "Réfrigérateur",
    sex: "m",
    category: "home",
    icon: "🧊",
    model: "/models/refrigerator.glb",
    pronunciation: "/audio/refrigerator.mp3",
  },
  {
    id: "car",
    name: "Car",
    translate: "Voiture",
    sex: "f",
    category: "vehicle",
    icon: "🚗",
    model: "/models/car.glb",
    pronunciation: "/audio/car.mp3",
  },
  {
    id: "bus",
    name: "Bus",
    translate: "Bus",
    sex: "m",
    category: "vehicle",
    icon: "🚌",
    model: "/models/bus.glb",
    pronunciation: "/audio/bus.mp3",
  },
  {
    id: "bicycle",
    name: "Bicycle",
    translate: "Vélo",
    sex: "m",
    category: "vehicle",
    icon: "🚲",
    model: "/models/bicycle.glb",
    pronunciation: "/audio/bicycle.mp3",
  },
  {
    id: "motorcycle",
    name: "Motorcycle",
    translate: "Moto",
    sex: "f",
    category: "vehicle",
    icon: "🏍️",
    model: "/models/motorcycle.glb",
    pronunciation: "/audio/motorcycle.mp3",
  },
  {
    id: "truck",
    name: "Truck",
    translate: "Camion",
    sex: "m",
    category: "vehicle",
    icon: "🚚",
    model: "/models/truck.glb",
    pronunciation: "/audio/truck.mp3",
  },
  {
    id: "train",
    name: "Train",
    translate: "Train",
    sex: "m",
    category: "vehicle",
    icon: "🚆",
    model: "/models/train.glb",
    pronunciation: "/audio/train.mp3",
  },
  {
    id: "airplane",
    name: "Airplane",
    translate: "Avion",
    sex: "m",
    category: "vehicle",
    icon: "✈️",
    model: "/models/airplane.glb",
    pronunciation: "/audio/airplane.mp3",
  },
  {
    id: "boat",
    name: "Boat",
    translate: "Bateau",
    sex: "m",
    category: "vehicle",
    icon: "🚤",
    model: "/models/boat.glb",
    pronunciation: "/audio/boat.mp3",
  },
];

export default objects;
